import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { requiredTranslatableZodSchema } from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { pageIdZodSchema } from "../page-id";

const pageDuplicateCommandZodObject = z.object({
    _id: idZodSchema,
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("PAGE_DUPLICATE_COMMAND"),
    source: z.object({
        pageId: pageIdZodSchema,
        ownerId: providerIdZodSchema.optional(),
    }),
    target: z.object({
        ownerId: providerIdZodSchema.optional(),
        title: requiredTranslatableZodSchema,
        pageId: pageIdZodSchema,
        slug: z.string(),
    }),
});
type PageDuplicateCommand = z.infer<typeof pageDuplicateCommandZodObject>;
const pageDuplicateCommandZodSchema: z.ZodSchema<PageDuplicateCommand> =
    pageDuplicateCommandZodObject;

type FactoryParams = Except<
    PageDuplicateCommand,
    "_id" | "_type" | "_createdAt"
>;
const pageDuplicateCommandFactory = (params: FactoryParams) => {
    const pageDuplicateCommand: PageDuplicateCommand = {
        ...params,
        _id: generateId({ prefix: "page_duplicate_command__" }),
        _type: "PAGE_DUPLICATE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return pageDuplicateCommand;
};

export { pageDuplicateCommandFactory, pageDuplicateCommandZodSchema };
export type {
    PageDuplicateCommand,
    FactoryParams as PageDuplicateCommandFactoryParams,
};
